export const Menu = {
    props: {
        smallScreenSize: {
            default: 780
        },
    },

    data() {
        return {
            showMenu: true,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
        };
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowHeight = window.innerHeight;
                this.windowWidth = window.innerWidth;
            });

            window.addEventListener('click', this.hideMenuIfSmallScreen);

            this.eventBus.$on('toggle-menu', this.toggleMenu);
            this.eventBus.$on('date-changed', this.hideMenuIfSmallScreen);
            this.eventBus.$on('selected-calendar', this.hideMenuIfSmallScreen);
            this.eventBus.$on('day-clicked', this.hideMenuIfSmallScreen);
            this.eventBus.$on('view-changed', this.hideMenuIfSmallScreen);
        });
    },

    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },

        hideMenu() {
            this.showMenu = false;
        },

        hideMenuIfSmallScreen() {
            if (this.isSmallScreen) {
                this.hideMenu();
            }
        },

        hideShowMenuByScreenSize() {
            if (this.isSmallScreen) {
                this.hideMenu();
            } else {
                this.showMenu = true;
            }
        }
    },

    computed: {
        isSmallScreen() {
            return this.windowWidth <= this.smallScreenSize;
        }
    },

    watch: {
        windowWidth() {
            this.hideShowMenuByScreenSize();
        }
    }
};
